import { render, staticRenderFns } from "./projects_list.vue?vue&type=template&id=6da6fa43&scoped=true&"
import script from "./projects_list.vue?vue&type=script&lang=js&"
export * from "./projects_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da6fa43",
  null
  
)

/* custom blocks */
import block0 from "./projects_list.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports